/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};
// extracted by mini-css-extract-plugin

/******/ })()
;



(function () {
  'use strict';

  function initBlogAjax() {

    const blogSection =
      document.querySelector('.blog-section-main');

    if (!blogSection) {
      return;
    }

    if (
      blogSection.dataset.ajaxInitialized === 'true'
    ) {
      return;
    }

    blogSection.dataset.ajaxInitialized = 'true';


    /*
     * =========================================================
     * LOAD BLOG USING AJAX
     * =========================================================
     */

    async function loadBlog(url, pushState = true) {

      try {

        blogSection.classList.add('is-loading');


        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });


        if (!response.ok) {
          throw new Error(
            'Unable to load blog content.'
          );
        }


        const html =
          await response.text();


        const parser =
          new DOMParser();


        const doc =
          parser.parseFromString(
            html,
            'text/html'
          );


        /*
         * NEW CONTENT
         */

        const newFeatured =
          doc.querySelector(
            '#blog-featured'
          );

        const newGrid =
          doc.querySelector(
            '#grid'
          );

        const newPagination =
          doc.querySelector(
            '#blog-pagination'
          );

        const newChips =
          doc.querySelector(
            '#chips'
          );


        /*
         * CURRENT CONTENT
         */

        const currentFeatured =
          blogSection.querySelector(
            '#blog-featured'
          );

        const currentGrid =
          blogSection.querySelector(
            '#grid'
          );

        const currentPagination =
          blogSection.querySelector(
            '#blog-pagination'
          );

        const currentChips =
          blogSection.querySelector(
            '#chips'
          );


        /*
         * FEATURED
         */

        if (currentFeatured) {

          if (newFeatured) {

            currentFeatured.replaceWith(
              newFeatured.cloneNode(true)
            );

          } else {

            currentFeatured.remove();

          }

        } else if (newFeatured) {

          const sectionTitle =
            blogSection.querySelector(
              '.section-title'
            );

          if (sectionTitle) {

            sectionTitle.parentNode.insertBefore(
              newFeatured.cloneNode(true),
              sectionTitle
            );

          }

        }


        /*
         * BLOG GRID
         */

        if (
          currentGrid &&
          newGrid
        ) {

          currentGrid.innerHTML =
            newGrid.innerHTML;

        }


        /*
         * PAGINATION
         */

        if (
          currentPagination &&
          newPagination
        ) {

          currentPagination.innerHTML =
            newPagination.innerHTML;

        }


        /*
         * FILTERS
         */

        if (
          currentChips &&
          newChips
        ) {

          currentChips.innerHTML =
            newChips.innerHTML;

        }


        /*
         * URL
         */

        if (pushState) {

          window.history.pushState(
            {
              blogAjax: true
            },
            '',
            url
          );

        }


        /*
         * SCROLL
         */

        const filterBar =
          blogSection.querySelector(
            '.filterbar'
          );

        if (filterBar) {

          const offset = 100;

          const position =
            filterBar.getBoundingClientRect().top +
            window.scrollY -
            offset;

          window.scrollTo({
            top: position,
            behavior: 'smooth'
          });

        }


      } catch (error) {

        console.error(
          'Blog AJAX Error:',
          error
        );

        /*
         * FALLBACK
         */

        window.location.href =
          url;

      } finally {

        blogSection.classList.remove(
          'is-loading'
        );

      }

    }


    /*
     * =========================================================
     * FILTER AJAX ONLY
     * =========================================================
     */

    blogSection.addEventListener(
      'click',
      function (event) {

        const filter =
          event.target.closest(
            '#chips .chip'
          );


        /*
         * IMPORTANT:
         * Only filter links are intercepted.
         */

        if (!filter) {
          return;
        }


        if (
          event.ctrlKey ||
          event.metaKey ||
          event.shiftKey ||
          event.altKey ||
          event.button !== 0
        ) {
          return;
        }


        event.preventDefault();


        const url =
          filter.href;


        if (!url) {
          return;
        }


        loadBlog(url);

      }
    );


    /*
     * =========================================================
     * PAGINATION AJAX ONLY
     * =========================================================
     */

    blogSection.addEventListener(
      'click',
      function (event) {

        const pagination =
          event.target.closest(
            '#blog-pagination a'
          );


        /*
         * IMPORTANT:
         * Article links are NOT included here.
         */

        if (!pagination) {
          return;
        }


        if (
          event.ctrlKey ||
          event.metaKey ||
          event.shiftKey ||
          event.altKey ||
          event.button !== 0
        ) {
          return;
        }


        event.preventDefault();


        const url =
          pagination.href;


        if (!url) {
          return;
        }


        loadBlog(url);

      }
    );


    /*
     * =========================================================
     * BROWSER BACK / FORWARD
     * =========================================================
     */

    window.addEventListener(
      'popstate',
      function () {

        loadBlog(
          window.location.href,
          false
        );

      }
    );

  }


  /*
   * =========================================================
   * INIT
   * =========================================================
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initBlogAjax
    );

  } else {

    initBlogAjax();

  }

})();